
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WidgetsModule } from '@acaprojects/ngx-widgets';

import { AttendeeModalComponent } from './attendee-modal/attendee-modal.component';
import { BookingModalComponent } from './booking-modal/booking-modal.component';
import { CalendarModalComponent } from './calendar-modal/calendar-modal.component';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { LevelSelectModalComponent } from './level-select-modal/level-select-model.component';
import { MapFilterModalComponent } from './map-filter-modal/map-filter-modal.component';
import { TimePeriodModalComponent } from './time-period-modal/time-period-modal.component';
import { NewVisitorModalComponent } from './new-visitor-model/new-visitor-modal.component';
import { VisitorModalComponent } from './visitor-modal/visitor-modal.component';
import { HostModalComponent } from './host-modal/host-modal.component';

import { SharedComponentModule } from '../shared/components/shared.module';
import { UserSearchModalComponent } from './user-search-modal/user-search-modal.component';

const OVERLAYS: any = [
    AttendeeModalComponent,
    BookingModalComponent,
    CalendarModalComponent,
    ConfirmModalComponent,
    LevelSelectModalComponent,
    MapFilterModalComponent,
    TimePeriodModalComponent,
    NewVisitorModalComponent,
    VisitorModalComponent,
    HostModalComponent,
    UserSearchModalComponent
];

@NgModule({
    declarations: [
        ...OVERLAYS
    ],
    imports: [
        CommonModule,
        FormsModule,
        WidgetsModule,
        SharedComponentModule
    ],
    exports: [
        ...OVERLAYS
    ],
    entryComponents: [
        ...OVERLAYS
    ]
})
export class OverlayComponentModule { }
